import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown, FaHistory } from "react-icons/fa";

const ComparePeriodFilter = ({
  handleApplyFilters,
  currentPeriodOptions,
  filters,
  isRTL,
}) => {
  const currentPeriodOption = currentPeriodOptions.find(
    (option) => option.value === filters.period_count
  );

  return (
    <Box h="full">
      <Menu>
        <MenuButton
          w="full"
          variant="outline"
          size="sm"
          textAlign={isRTL ? "right" : "left"}
          h="40px"
          display="flex"
          alignItems="center"
        >
          <HStack
            spacing={2}
            w="full"
            justify={isRTL ? "flex-end" : "flex-start"}
          >
            {isRTL && <Icon as={FaChevronDown} />}
            <Icon as={FaHistory} color="purple.500" />
            <Text noOfLines={1} flex={1}>
              {currentPeriodOption?.label ||
                (isRTL ? "اختر المقارنة" : "Select comparison")}
            </Text>
            {!isRTL && <Icon as={FaChevronDown} />}
          </HStack>
        </MenuButton>
        <MenuList maxH="300px" overflowY="auto" minW="200px">
          {currentPeriodOptions.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => handleApplyFilters({ period_count: option.value })}
              fontWeight={
                option.value === filters.period_count ? "bold" : "normal"
              }
              bg={option.value === filters.period_count ? "blue.50" : "white"}
              textAlign={isRTL ? "right" : "left"}
            >
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default ComparePeriodFilter;
